import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";
import CookieConsent from "react-cookie-consent";

import RichtextRenderer from "./RichtextRenderer";
import Button from "./basic/Button";

function CookieConsentBanner() {
  const { language } = useI18next();
  const { dataEn, dataFr } = useStaticQuery(graphql`
    query CookieConsentBanner {
      dataEn: contentfulHeaderAndFooter(node_locale: { eq: "en-US" }) {
        cookieConsentTitle
        cookieConsentContent {
          raw
        }
        cookieConsentAcceptButtonLabel
        cookieConsentDeclineButtonLabel
      }

      dataFr: contentfulHeaderAndFooter(node_locale: { eq: "fr" }) {
        cookieConsentTitle
        cookieConsentContent {
          raw
        }
        cookieConsentAcceptButtonLabel
        cookieConsentDeclineButtonLabel
      }
    }
  `);

  const data = language === "fr" ? dataFr : dataEn;

  if (typeof window !== "undefined") {
    const searchParams = new URLSearchParams(window.location.search);
    const noCookieBar = searchParams.has("noCookieBar");

    if (noCookieBar) {
      return null;
    }
  }

  return (
    <CookieConsent
      enableDeclineButton
      disableButtonStyles
      declineButtonText={data.cookieConsentDeclineButtonLabel}
      buttonText={data.cookieConsentAcceptButtonLabel}
      ButtonComponent={Button}
      customButtonProps={{ variant: "blue" }}
      customDeclineButtonProps={{ variant: "white" }}
      buttonClasses="order-first border border-blue border-box mt-16px md:mt-0"
      declineButtonClasses="!bg-transparent border border-blue border-box mt-16px md:mt-0 md:ml-16px"
      containerClasses="!block !bg-white border-t border-text-blue !text-blue px-24px md:px-64px py-16px"
      contentClasses="max-w-1440px !mx-auto"
      buttonWrapperClasses="w-full max-w-1440px !mx-auto flex flex-col md:flex-row items-center mt-24px mb-16px"
      cookieName="gatsby-gdpr-google-analytics"
    >
      <h2>{data.cookieConsentTitle}</h2>
      <div className="mt-4">
        <RichtextRenderer data={data.cookieConsentContent} />
      </div>
    </CookieConsent>
  );
}

export default CookieConsentBanner;
